import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Import Components
import MiniWidgets from "./MiniWidgets";
import RecentlyActivity from "./RecentlyActivity";
import LatestTransactions from "./LatestTransactions";

// Import des services
import { GetZonesStats } from "../../services/ZonesServices/Api";
import { GetlisteReservation, calculateConferenceReservations} from "../../services/ReservationServices/api";
import { GetTopAnimals } from "../../services/AnimalsServices/Api";
import { GetDownloadsStats } from "../../services/AppStatsServices/Api";

const Dashboard = () => {
    const [totalReservationRequests, setTotalReservationRequests] = useState(0);
    const [conferenceReservationsThisWeek, setConferenceReservationsThisWeek] = useState(0);
    const [birthdayReservationsThisWeek, setBirthdayReservationsThisWeek] = useState(0);
  
    const [ZonesStats, setZonesStats] = useState([]);
    const [ZonesStatsnbr, setZonesStatsnbr] = useState(0);
    const [ZonesStatsName, setZonesStatsName] = useState("0");
  
    const [ReservStats, setReservStats] = useState([]);
    const [ReservStatsName, setReservStatsName] = useState("");
  
    const [topAnimals, setTopAnimals] = useState([]);
  
    // State pour les stats d'application
    const [totalDownloads, setTotalDownloads] = useState(0);
    const [downloadsThisWeek, setDownloadsThisWeek] = useState(0);
  

    useEffect(() => {
        const GetData = async () => {
          try {
            // Fetch stats pour les zones
            const zoneStatsRes = await GetZonesStats();
            const totalNbr = zoneStatsRes.reduce((total, zone) => total + zone.nbr, 0);
            setZonesStatsnbr(totalNbr);
      
            const topZone = zoneStatsRes.reduce((max, zone) => (zone.nbr > max.nbr ? zone : max), zoneStatsRes[0]);
            setZonesStatsName(topZone.nom);
      
            const sortedZones = zoneStatsRes.sort((a, b) => b.nbr - a.nbr);
            setZonesStats(sortedZones);
      
            // Fetch downloads stats
            const downloadsStatsRes = await GetDownloadsStats();
            setTotalDownloads(downloadsStatsRes.totalDownloads);
      
            if (downloadsStatsRes.downloadsThisWeek) {
              setDownloadsThisWeek(downloadsStatsRes.downloadsThisWeek);
            } else {
              const today = new Date();
              const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 1));
              const weeklyDownloads = downloadsStatsRes.downloads.filter(
                (download) => new Date(download.createAt) >= startOfWeek
              ).length;
              setDownloadsThisWeek(weeklyDownloads);
            }
      
            // Fetch réservation stats
            const reservationRes = await GetlisteReservation();
            setTotalReservationRequests(reservationRes.length);
      
            const conferenceCount = reservationRes.filter(
              (item) => item.pageReservation.title_fr === "SALLE DE CONFÉRENCES"
            ).length;
            setConferenceReservationsThisWeek(conferenceCount);
      
            const birthdayCount = reservationRes.filter(
              (item) => item.pageReservation.title_fr === "SALLES D’ANNIVERSAIRE"
            ).length;
            setBirthdayReservationsThisWeek(birthdayCount);
      
            const refCount = reservationRes.reduce((acc, item) => {
              acc[item.pageReservation.ref] = (acc[item.pageReservation.ref] || 0) + 1;
              return acc;
            }, {});
      
            const maxRef = Object.keys(refCount).reduce(
              (max, key) => (refCount[key] > refCount[max] ? key : max),
              Object.keys(refCount)[0]
            );
            setReservStatsName(maxRef);
      
            const sortedReservations = reservationRes.sort((a, b) => new Date(b.dateReservation) - new Date(a.dateReservation));
            setReservStats(sortedReservations.slice(0, 4));
      
            // Fetch top animals
            const topAnimalsRes = await GetTopAnimals();
            setTopAnimals(topAnimalsRes);
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
      
        GetData();
      }, []);
      

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <MiniWidgets
              reports={[
                {
                  value: ZonesStatsnbr,
                  title: "Nombre total de visiteurs",
                  icon: "fas fa-user-friends",
                },
                {
                  value: ZonesStatsName,
                  title: "La zone la plus visitée",
                  icon: "fas fa-map-signs",
                },
                {
                  value: ReservStatsName,
                  title: "L'expérience la plus convoitée",
                  icon: "fas fa-calendar-week",
                },
                {
                  value: `${topAnimals.length} - ${topAnimals[0]?.name || "Aucun animal"}`,
                  title: "Top 10 des animaux",
                  icon: "fas fa-heart",
                },
                {
                  value: totalDownloads,
                  title: "Nombre total de téléchargements",
                  icon: "fas fa-download",
                },
                {
                  value: downloadsThisWeek,
                  title: "Téléchargements ajoutés cette semaine",
                  icon: "fas fa-calendar-week",
                },
                {
                  value: totalReservationRequests,
                  title: "Nombre total de demandes de réservation",
                  icon: "fas fa-calendar-check",
                },
                {
                  value: conferenceReservationsThisWeek,
                  title: "Réservations de la salle de conférence",
                  icon: "fas fa-meeting",
                },
                {
                  value: birthdayReservationsThisWeek,
                  title: "Réservations de la salle d’anniversaire",
                  icon: "fas fa-birthday-cake",
                },
              ]}
            />
          </Row>
          <Row>
            <RecentlyActivity latestFiles={ReservStats} />
            <LatestTransactions latestMembers={ZonesStats} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;

